<template>
  <div class="page" id="agents">
    <div class="d-flex justify-content-end my-2">
      <router-link to="/agents/create">
        <button class="btn btn-primary shadow-none px-4 py-3">
          {{ $t('agents.agents.create-agent') }}
        </button>
      </router-link>
    </div>
    <data-table
      ref="agentsTable"
      :fields="translatedTableFields"
      :data="agents"
      :pagination="pagination"
      :loading="isLoading"
      @changePage="onPageChange"
    >
      <template slot="status" slot-scope="props">
        <div class="table-button-container">
          <span
            class="badge"
            :class="props.row.isDeleted ? 'badge-danger' : 'badge-primary'"
          >
            {{
              props.row.isDeleted
                ? $t('agents.agents.table.statuses.deleted')
                : $t('agents.agents.table.statuses.active')
            }}
          </span>
        </div>
      </template>

      <template slot="actions" slot-scope="props">
        <div class="table-button-container">
          <router-link :to="`/agents/${props.row.id}/update`">
            <button class="btn btn-sm btn-warning px-3 mx-1">
              <i class="fa fa-pencil" aria-hidden="true"></i>
            </button>
          </router-link>
          <button
            class="btn btn-sm btn-info px-3 mx-1"
            @click="restoreAgent(props.row.id)"
            v-if="props.row.isDeleted"
          >
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>
          <button
            class="btn btn-sm btn-danger px-3 mx-1"
            @click="deleteAgent(props.row.id)"
            v-else
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import agentService from '../../../services/agent.service'
import DataTable from '../../../elements/Table'

export default {
  components: {
    DataTable
  },
  name: 'agents',
  data() {
    return {
      agents: [],
      isLoading: false,
      tableFields: [
        {
          accessor: 'name',
          header: 'agents.agents.table.name'
        },
        {
          accessor: 'email',
          header: 'agents.agents.table.email'
        },
        {
          accessor: 'status',
          header: 'agents.agents.table.status'
        },
        {
          accessor: 'actions',
          header: 'agents.agents.table.actions'
        }
      ],
      pagination: {
        page: 1,
        limit: 10,
        totalPages: 0,
        totalItems: 0
      }
    }
  },
  computed: {
    translatedTableFields() {
      return this.tableFields.map(field => {
        return {
          ...field,
          header: this.$t(field.header)
        }
      })
    }
  },
  methods: {
    async getAgents(page) {
      this.isLoading = true
      try {
        const {
          agents,
          totalPages,
          totalItems
        } = await agentService.getAllAgents(page)
        this.agents = agents
        this.pagination.totalPages = totalPages
        this.pagination.totalItems = totalItems
      } catch (error) {
        this.toast(error.message, { type: 'error' })
      } finally {
        this.isLoading = false
      }
    },
    onPageChange(page) {
      this.pagination.page = page
      this.getAgents(page)
    },
    async restoreAgent(agentId) {
      this.isLoading = true

      try {
        const res = await agentService.restoreAgent(agentId)
        await this.getAgents()
      } catch (error) {
        this.toast(error.message, { type: 'error' })
      } finally {
        this.isLoading = false
      }
    },
    async deleteAgent(agentId) {
      this.isLoading = true

      try {
        const res = await agentService.deleteAgent(agentId)
        await this.getAgents()
      } catch (error) {
        this.toast(error.message, { type: 'error' })
      } finally {
        this.isLoading = false
      }
    }
  },
  mounted() {
    this.getAgents()
  }
}
</script>

<style lang="scss" scoped></style>
